export const coreApiRoutes = {
  auth: {
    refreshToken: 'auth/refresh-token',
    email: {
      login: 'auth/email/login',
      registrationConfirmation: 'auth/email/registration-confirmation',
      passwordChange: 'auth/email/password-change',
      passwordResetRequest: 'auth/email/password-reset-request',
      passwordReset: 'auth/email/password-reset',
    },
    google: {
      login: 'auth/google/login',
    },
  },
  translations: {
    list: 'translations',
    update: 'translations/:id',
  },
  languages: {
    locale: 'languages/locale/:locale',
    options: 'languages/options',
  },
  users: {
    get: 'users/:id',
    me: 'users/me',
    list: 'users',
    create: 'users',
    update: 'users/:id',
    resendActivation: 'users/:id/resend-activation',
    delete: 'users/:id',
    selfDeleteRequest: 'users/self-delete-request',
    selfDelete: 'users/self-delete/:token',
    selfIdentityChangeRequest: 'users/self-identity-change-request',
    selfIdentityChange: 'users/self-identity-change/:token',
    bulkDelete: 'users/bulk-delete',
    impersonate: 'users/:id/impersonate',
  },
  userTokens: {
    get: 'user-tokens/:token',
  },
  userSettings: {
    updateSelf: 'user-settings/update-self',
    getSelf: 'user-settings/get-self',
    getLayoutOptions: 'user-settings/options/layout',
  },
  profile: {
    updateSelf: 'profile/update-self',
    getSelf: 'profile/get-self',
  },
  roles: {
    options: 'roles/options',
    optionsCompanyAdmins: 'roles/options/company-admins',
    optionsCompanyScoped: 'roles/options/company-scoped',
    optionsFilter: 'roles/options-filter',
    mappedAccess: 'roles/mapped-access',
  },
  assets: {
    getAsset: 'assets/:id',
    uploadImage: 'assets/upload-image',
    uploadPrivateFile: 'assets/upload-private-file',
    uploadPrivateFiles: 'assets/upload-private-files',
    uploadFiles: 'assets/upload-files',
    getOwnedAsset: 'assets/owned/:id',
    downloadFile: 'assets/download-file/:id',
    getDownloadableFile: 'assets/get-downloadable-file/:id',
    getOwnedDownloadableFile: 'assets/get-owned-downloadable-file/:id',
  },
  health: {
    version: 'health/version',
  },
  audit: {
    list: 'audit',
  },
  entityTranslations: {
    get: 'entity-translations/entity',
  },
  companies: {
    get: 'companies/:id',
    getCurrentCompany: 'companies/me',
    list: 'companies',
    options: 'companies/options',
    create: 'companies',
    update: 'companies/:id',
    updateCurrentCompany: 'companies/me',
    updateAdmins: 'companies/:id/admins',
    updateCurrentCompanyAdmins: 'companies/me/admins',
    archive: 'companies/:id/archive',
    delete: 'companies/:id',
    getLegalInfo: 'companies/legal-info',
    duplicate: 'companies/:id/duplicate',
  },
  emails: {
    list: 'email',
  },
  weekdays: {
    options: 'weekdays/options',
  },
  companyRoles: {
    get: 'company-roles/:id',
    list: 'company-roles',
    create: 'company-roles',
    update: 'company-roles/:id',
    delete: 'company-roles/:id',
    options: 'company-roles/options',
    optionsCurrent: 'company-roles/options/current',
  },
  companyPermissions: {
    getPermissionsMatrix: 'company-permissions/matrix',
    getCompanyPermissionsMatrix: 'company-permissions/:companyId/matrix',
    savePermissionsMatrix: 'company-permissions/matrix',
    saveCompanyPermissionsMatrix: 'company-permissions/:companyId/matrix',
    getPermissionOptions: 'company-permissions/permission-options',
  },
  companyUsers: {
    list: 'company-users',
    listGetCurrent: 'company-users/current',
    get: 'company-users/:id',
    getCurrent: 'company-users/:id/current',
    create: 'company-users',
    createCurrent: 'company-users/current',
    update: 'company-users/:id',
    updateCurrent: 'company-users/:id/current',
    delete: 'company-users/:id',
    deleteCurrent: 'company-users/:id/current',
  },
};
